// src/servicios/autenticacion.js
import { auth, db } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth'; // Importación corregida
import { doc, getDoc } from 'firebase/firestore';

const mapearErrores = (error) => {
  const errores = {
    'auth/invalid-email': 'Correo electrónico inválido',
    'auth/wrong-password': 'Contraseña incorrecta',
    'auth/user-not-found': 'Usuario no registrado',
    'auth/too-many-requests': 'Demasiados intentos fallidos. Intente más tarde',
    'auth/user-disabled': 'Cuenta deshabilitada',
    'auth/requires-recent-login': 'La sesión ha expirado. Vuelva a autenticarse',
    'permission-denied': 'No tiene permisos para acceder',
    'app/network-error': 'Error de conexión. Verifique su internet'
  };
  return errores[error.message] || error.message; // Modificado para acceder a message
};

export const login = async (email, password, rolSeleccionado) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    const [adminDoc, usuarioDoc] = await Promise.all([
      getDoc(doc(db, "administradores", user.uid)),
      getDoc(doc(db, "usuarios", user.uid))
    ]);

    if (adminDoc.exists()) {
      const datosAdmin = adminDoc.data();
      
      if (datosAdmin.rol !== 'superadmin') throw new Error('permission-denied');
      if (datosAdmin.estado !== 'activo') throw new Error('auth/user-disabled');
      if (rolSeleccionado !== 'superadmin') throw new Error('permission-denied');

      return {
        uid: user.uid,
        email: user.email,
        rol: 'superadmin',
        estado: datosAdmin.estado,
        ...datosAdmin
      };
    }

    if (usuarioDoc.exists()) {
      const datosUsuario = usuarioDoc.data();
      
      if (datosUsuario.estado !== 'activo') throw new Error('auth/user-disabled');
      if (rolSeleccionado !== 'usuario') throw new Error('permission-denied');

      return {
        uid: user.uid,
        email: user.email,
        rol: 'usuario',
        estado: datosUsuario.estado,
        ...datosUsuario
      };
    }

    throw new Error('auth/user-not-found');

  } catch (error) {
    await auth.signOut();
    throw new Error(mapearErrores(error));
  }
};

